
$(document).one('shown.bs.tab', '#all_sick_leaves-tab', function(e){
    window.LaravelDataTables["sick_leaves_table"].columns.adjust().draw();
});

$(document).one('shown.bs.tab', '#healthy_employees-tab', function(e){
    console.log(e)
    window.LaravelDataTables["nonsickemployees"].columns.adjust().draw();
});

$(document).on('shown.bs.tab', '#sick_leave-dossier-tab', function(e){
    let tableId = 'sick_leaves_dossier_table'+$(e.target).data('parentable_id');
    window.LaravelDataTables[tableId].columns.adjust().draw();
});

// EmployeeSickLeave
$(document).on('submit', '#edit_employee_sick_leave', function(e){
    e.preventDefault();
    e.stopPropagation();

    let formData = new FormData($(this)[0]);

    $.ajax({
        type: 'POST',
        url: $(this).attr('action'),
        data: formData,
        async: false,
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function(data){
            // Hide validation errors
            $('#edit_sick_leave_modal_errors').addClass('d-none');

            // Close modal
            $('#edit_sick_leave_modal').modal('hide');

            // Show feedback
            $.notify({
                message: 'Ziekteverzuim opgeslagen'
            });

            // Reload datatable
            if ("employee_sick_leaves_table" in window.LaravelDataTables) {
                window.LaravelDataTables["employee_sick_leaves_table"].ajax.reload(null, false);
            }
            if ("current_sick_leaves_table" in window.LaravelDataTables) {
                window.LaravelDataTables["current_sick_leaves_table"].ajax.reload(null, false);
            }
            if ("sick_leaves_table" in window.LaravelDataTables) {
                window.LaravelDataTables["sick_leaves_table"].ajax.reload(null, false);
            }
            if ("nonsickemployees" in window.LaravelDataTables) {
                window.LaravelDataTables["nonsickemployees"].ajax.reload(null, false);
            }
        },
        error: function(jqXHR){
            // Show validation errors
            $('#edit_sick_leave_modal_errors ul li').remove();

            $.each(jqXHR.responseJSON.errors, function(key, errors){
                $.each(errors, function(key, error){
                    $('#edit_sick_leave_modal_errors ul').append('<li>'+error+'</li>');
                });
            });

            $('#edit_sick_leave_modal_errors').removeClass('d-none');
        }
    });
});

$(document).on('click', '.employee_sick_leave_destroy', function(e){
    e.preventDefault();
    e.stopPropagation();

    // Ask for confirmation before destroying
    Swal.fire({
        title: 'Weet u zeker dat u dit ziekteverzuim wilt verwijderen?',// @todo @lang
        text: "Dit kan niet ongedaan worden!",// @todo @lang
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Annuleren',// @todo @lang
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Verwijderen'// @todo @lang
    }).then((result) => {
        if (result.isConfirmed) {
            // Send ajax request for destroying the object
            $.ajax({
                type: 'POST',
                url: $(this).data('route'),
                data: {
                    "_method": "DELETE",
                    "_token": $(this).parents('form').find('input[name="_token"]').val()
                },
                dataType: 'json',
                success: function(data){
                    // Show feedback
                    $.notify({
                        message: 'Ziekteverzuim verwijderd'// @todo @lang
                    });

                    // Reload datatable
                    if ("employee_sick_leaves_table" in window.LaravelDataTables) {
                        window.LaravelDataTables["employee_sick_leaves_table"].ajax.reload(null, false);
                    }
                    if ("sick_leaves_table" in window.LaravelDataTables) {
                        window.LaravelDataTables["sick_leaves_table"].ajax.reload(null, false);
                    }
                },
                error: function(jqXHR){
                    // Show feedback
                    $.notify({
                        message: 'Er is iets misgegaan met het verwijderen van het ziekteverzuim. Probeer het nogmaals.'// @todo @lang
                    }, {
                        type: 'danger'
                    });
                }
            });
        }
    });
});

$(document).on('click', '#sick_leave_period_add', function(e){
    let $clone = $('.sick_leave_period_row:first').clone();

    $clone.find('input').val(null);
    $clone.find('.datepicker:first').removeClass('flatpickr-input');
    $clone.find('.datepicker:last').remove();
    $clone.insertAfter('.sick_leave_period_row:last');

    indexSickLeavePeriodRows();

    flatpickr($clone.find('.datepicker'));
});

$(document).on('click', '.sick_leave_period_remove', function(e){
    if($('.sick_leave_period_row').index($(this).parents('.sick_leave_period_row')) == 0){
        return;
    }

    $(this).parents('.sick_leave_period_row').remove();

    indexSickLeavePeriodRows();
});

function indexSickLeavePeriodRows(){
    $('.sick_leave_period_row').each(function(key, value){
        let number = key + 2;

        $(this).find('.sick_leave_period_remove').toggle(key !== 0);

        $(this).find('.sick_leave_period_nr').text(number);
        $(this).find('input[name^="periods["][name$="][date]"]').attr('name', 'periods['+key+'][date]');
        $(this).find('input[name^="periods["][name$="][percentage]"]').attr('name', 'periods['+key+'][percentage]');
    });
}

/**
 * When selecting an item in the link_work_accident select add it the
 * the list of selected work accidents and disable the corresponding option
 */
 $(document).on('change', 'select[name="link_work_accident"]', function(e){
    let work_accident_id = $(this).find('option:selected').val();
    if(!work_accident_id.length){// No work_accident selected, skip
        return;
    }

    let name = $(this).find('option:selected').text();
    $(this).find('option:selected').prop('disabled', true);
    $(this).val(null);
    initSelect2($(this).parents('.modal-content'));

    $clone = $('#sick_leave_work_accident_template>div').clone();
    $clone.find('.name').text(name);
    $clone.find('input[name="linked_work_accident[]"]').val(work_accident_id);

    $('#linked_work_accidents').append($clone);
});

/**
 * When removing an sick_leave from the list of linked sick_leaves remove the
 * row and enable the corresponding option in the select field
 */
$(document).on('click', '.unlink_sick_leave_work_accident', function(e){
    let $item = $(this).parents('.linked_work_accident_element');
    let work_accident_id = $item.find('input[name="linked_work_accident[]"]').val();

    $item.remove();

    $('select[name="link_work_accident"]').find('option[value="'+work_accident_id+'"]').prop('disabled', false);
    initSelect2($(this).parents('.modal-content'));
});
